import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "segmented-button tw-flex" }
const _hoisted_2 = ["data-test", "onClick"]
const _hoisted_3 = ["data-test"]

import SVGIcon from 'frontcore/views/icons/SVGIcon.vue'
import {
  SegmentedButtonItem,
  SegmentedButtonItemStyle,
} from 'frontcore/views/segmented-button/types'

type Props = {
  items: SegmentedButtonItem[]
  value: number,
}
type Emits = (e: 'input', id: Props['value']) => void

export default /*@__PURE__*/_defineComponent({
  __name: 'SegmentedButton',
  props: {
    items: {},
    value: {}
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const onClick = (item: SegmentedButtonItem) => {
  if (item.disabled) { return }
  emit('input', item.id)
}

const defaultItemStyle: SegmentedButtonItemStyle = {
  unselected: {
    icon: 'fill-core-primary-30',
    button: 'hover:bg-core-primary-95 active:bg-core-primary-90',
  },
  selected: {
    icon: 'fill-core-primary-30',
    button: 'bg-core-primary-80 hover:bg-core-primary-70 active:bg-core-primary-60',
  },
}

const itemStyle = (item: SegmentedButtonItem) => {
  const selected = item.id === props.value
  const style = { ...(item.style ?? defaultItemStyle) }
  const selectedStyle = selected ? style.selected : style.unselected

  let button: (Record<string, boolean> | string)[] = [
    {'segmented-button__item--selected': selected, 'segmented-button__item--disabled': item?.disabled || false },
  ]
  if (!item.disabled && selectedStyle.button) {
    button.push(selectedStyle.button)
  }

  if (selected && item.disabled && style.selected.disabledButton) {
    button = [style.selected.disabledButton]
  }

  return {
    button,
    icon: selectedStyle.icon ?? '',
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createElementBlock("button", {
        key: item.id,
        class: _normalizeClass([
        'segmented-button__item',
        'tw-flex tw-gap-1 tw-items-center tw-justify-center',
        'tw-px-4 tw-py-2',
        itemStyle(item).button,
      ]),
        "data-test": `segmented-button-item-${item.id}`,
        onClick: () => onClick(item)
      }, [
        (item.iconName)
          ? (_openBlock(), _createBlock(SVGIcon, {
              key: 0,
              colorClass: itemStyle(item).icon,
              iconName: item.iconName,
              remSize: 1.25
            }, null, 8, ["colorClass", "iconName"]))
          : _createCommentVNode("", true),
        (item.label)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              "data-test": `segmented-button-item-${item.id}-label`,
              class: _normalizeClass([
          'segmented-button__item__label',
          'buttons--button-01',
          item.iconName ? 'tw-hidden sm:tw-flex' : ''
        ])
            }, _toDisplayString(item.label), 11, _hoisted_3))
          : _createCommentVNode("", true)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})